import { Component, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#0a0a0a',
          color: '#fff',
          fontFamily: 'Inter, sans-serif',
          padding: '20px',
          textAlign: 'center'
        }}>
          <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>🚀 Oops! Algo deu errado</h1>
          <p style={{ fontSize: '1rem', marginBottom: '2rem', maxWidth: '600px' }}>
            {this.state.error?.message || 'Erro desconhecido'}
          </p>
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <button
              onClick={() => {
                // Forçar reload completo sem cache
                window.location.href = window.location.origin + window.location.pathname + '?t=' + Date.now();
              }}
              style={{
                padding: '12px 24px',
                fontSize: '1rem',
                backgroundColor: '#00ffcc',
                color: '#0a0a0a',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              Recarregar Página
            </button>
            <button
              onClick={() => {
                // Tentar resetar o erro e voltar ao menu
                this.setState({ hasError: false, error: null });
                // Navegar para home
                window.history.pushState({}, '', '/');
              }}
              style={{
                padding: '12px 24px',
                fontSize: '1rem',
                backgroundColor: '#333',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              Voltar ao Menu
            </button>
          </div>
          <details style={{ marginTop: '2rem', maxWidth: '800px', textAlign: 'left' }}>
            <summary style={{ cursor: 'pointer', marginBottom: '1rem' }}>
              Detalhes técnicos (para desenvolvedores)
            </summary>
            <pre style={{ 
              backgroundColor: '#1a1a1a', 
              padding: '1rem', 
              borderRadius: '4px',
              overflow: 'auto',
              fontSize: '0.875rem'
            }}>
              {this.state.error?.stack}
            </pre>
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}
